import { combineReducers } from '@reduxjs/toolkit';
// Remove unused asset-related reducers
import selectedOrderItems from './selectedOrderItems';
import orderItemChanges from './orderItemChanges';
import shipmentCarriers from './shipmentCarriers';
import searchReducer from './search';

// Initialize the shipping reducer with the correct state shape
const shippingReducer = combineReducers({
  // Remove unused asset-related reducers
  selectedOrderItems,
  orderItemChanges,
  shipmentCarriers,
  search: searchReducer,
});

export default shippingReducer;
